import { UserAccessRoleRules } from '@src/auth/user-access-roles-rules';
import { Injectable } from '@angular/core';
import { UserRolesEnum } from '@src/model/userRoles';

@Injectable()
export class FrederiqueAccessRules extends UserAccessRoleRules {
    rules = {};
    constructor() {
        super();
        this.rules = {};
        this.rules['dashboard'] = [
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.AGENT,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.RETAILER,
            UserRolesEnum.GUEST
        ];
        this.rules['sales'] = [
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.AGENT,
            UserRolesEnum.REPAIR,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.RETAILER,
            UserRolesEnum.GUEST
        ];
        this.rules['sales-details'] = [
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.AGENT,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.RETAILER,
            UserRolesEnum.GUEST,
            UserRolesEnum.SELLER,
            UserRolesEnum.GENERICSELLER,
            UserRolesEnum.REPAIR
        ];
        this.rules['activation'] = [
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.AGENT,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.RETAILER,
            UserRolesEnum.SELLER,
            UserRolesEnum.GENERICSELLER
        ];
        this.rules['users'] = [
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.RETAILER,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.AGENT
        ];
        this.rules['retailers'] = [
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.AGENT,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.GUEST
        ];
        this.rules['retailer'] = [ UserRolesEnum.RETAILER ];
        this.rules['public'] = [
            UserRolesEnum.ANONYMOUS,
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.AGENT,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.RETAILER,
            UserRolesEnum.GUEST
        ];
        this.rules['management'] = [ UserRolesEnum.ADMIN, UserRolesEnum.MARKET_ADMIN ];
        this.rules['repair'] = [ UserRolesEnum.ADMIN, UserRolesEnum.MARKET_ADMIN, UserRolesEnum.REPAIR ];
        this.rules['customers'] = [
            UserRolesEnum.RETAILER,
            UserRolesEnum.ADMIN,
            UserRolesEnum.MASTER_RETAILER
        ];
        this.rules['inventories'] = [
            UserRolesEnum.ADMIN,
            UserRolesEnum.MARKET_ADMIN,
            UserRolesEnum.AGENT,
            UserRolesEnum.MASTER_RETAILER,
            UserRolesEnum.RETAILER,
        ];
    }
}
